import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import SearchPage from './pages/SearchPage';
import DetailPage from './pages/DetailPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Registration from './pages/Registration';
import ErrorPage from './pages/ErrorPage';
import { defaultHome } from './utils/utils';
import DefaultLayout from './layout/DefaultLayout';

function App() {
  return(
    <Routes>
      <Route path='/' element={<DefaultLayout/>} >
        <Route path="/" element={<Navigate to={defaultHome} />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/home" element={<SearchPage />} />
        <Route path="/detail/:intType/:invNo/:invType/:compName" element={<DetailPage />} />
        <Route path="/detail//:invNo/:invType/:compName" element={<DetailPage />} />
        <Route path="/password/forgot" element={<ForgotPassword />} />
        <Route path="/password/reset" element={<ResetPassword />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/Account/Login.aspx" element={<Navigate to={"/login"} />} />
        <Route path="/Account/register.aspx" element={<Navigate to={"/register"} />} />
      </Route>
    </Routes>
  )
}

export default App;
